import { createAsyncThunk } from '@reduxjs/toolkit';
import { SeoAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { SEO_SLICE_NAME } from './models';
import { IRobotsResponse, IUpdateRobotsDTO } from '@/models/seo.model';

export const getRobotsData = createAsyncThunk<IRobotsResponse, undefined, { serializedErrorType: IApiError }>(
  `${SEO_SLICE_NAME}/getRobotsData`,
  async () => {
    const response = await SeoAPI.getRobotsData();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateRobotsData = createAsyncThunk<IRobotsResponse, IUpdateRobotsDTO, { serializedErrorType: IApiError }>(
  `${SEO_SLICE_NAME}/updateRobotsData`,
  async (data) => {
    const response = await SeoAPI.updateRobotsData(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
